import { colors, Grid, gutter, opacity, radius } from '@lamimed/pantheon';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';

export const Wrapper = styled(Grid.Wrapper)`
  scroll-margin: 32rem;
`;

export const HeaderContent = styled.div`
  padding: ${gutter.default};
  padding-right: 0;
`;

export const ListItem = styled.li<{ selected?: boolean }>`
  ${({ selected }) => css`
    align-items: center;
    border-radius: ${radius.small};
    cursor: pointer;
    display: grid;
    gap: ${gutter.small};
    grid-template-columns: ${selected
      ? `auto 1fr auto`
      : `auto 1fr auto 4.8rem`};
    margin: ${selected ? '0' : `0 ${gutter.small}`};
    padding: ${selected ? gutter.default : gutter.small};
    transition: background-color 0.3s ease-in-out;

    ${!selected &&
    css`
      &:hover {
        background-color: ${rgba(colors.light, 0.25)};
      }
    `}
  `}
`;

export const ListItemIcon = styled.span`
  align-items: center;
  background-color: ${colors.light};
  border-radius: ${radius.small};
  display: flex;
  height: 6rem;
  justify-content: center;
  width: 6rem;

  > div {
    align-items: center;
    background: ${colors.gradient__primary_diagonal};
    border-radius: ${radius.small};
    display: flex;
    height: 4.2rem;
    justify-content: center;
    width: 4.2rem;
  }
`;

export const ListItemDivider = styled.span`
  background-color: ${rgba(colors.neutral, opacity.hard)};
  height: 4rem;
  width: 0.1rem;
`;

export const ListItemEdit = styled.button`
  background: ${colors.light};
  border-radius: ${radius.small};
  border: 0;
  cursor: pointer;
  height: 4.8rem;
  width: 4.8rem;
`;
